import { useState } from "react";
import { arcs } from "@/mocks/home";

export default function ArcsSection() {
  const [openId, setOpenId] = useState<string | null>(arcs[0]?.id ?? null);

  return (
    <section id="arcs" className="section-anchor w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="reveal max-w-2xl">
          <span className="text-xs font-label tracking-[0.2em] text-primary-300">篇章导览 / STORY ARCS</span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl text-background-50">
            按篇章顺序，看懂整部作品
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/80">
            作品可以大致分为六个阶段。点击任意篇章即可展开该阶段的看点，帮助你决定从哪里开始补、哪些部分最值得期待。
          </p>
        </div>

        <div className="reveal mt-10 rounded-lg border border-background-50/15 overflow-hidden">
          {arcs.map((arc, idx) => {
            const isOpen = openId === arc.id;
            return (
              <div key={arc.id} className={idx !== 0 ? "border-t border-background-50/15" : ""}>
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : arc.id)}
                  aria-expanded={isOpen}
                  className="w-full text-left px-4 md:px-6 py-5 flex items-center gap-4 hover:bg-background-50/5 transition-colors"
                >
                  <span className="shrink-0 font-heading text-lg md:text-xl text-primary-300 w-10">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="flex flex-wrap items-center gap-2">
                      <span className="font-heading text-lg md:text-xl text-background-50">{arc.title}</span>
                      <span className="px-2.5 py-0.5 rounded-full text-xs bg-accent-500/90 text-background-50">
                        {arc.tone}
                      </span>
                      <span className="text-xs text-background-300/70">{arc.range}</span>
                    </span>
                  </span>
                  <i
                    className={`shrink-0 text-background-200 transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    } text-xl`}
                  />
                </button>

                {isOpen && (
                  <div className="px-4 md:px-6 pb-6 pl-14 md:pl-20">
                    <p className="text-sm md:text-base leading-relaxed text-background-100/85">{arc.summary}</p>
                    <ul className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-2.5">
                      {arc.points.map((p) => (
                        <li
                          key={p}
                          className="rounded-md bg-background-50/10 border border-background-50/20 px-3 py-2.5 text-xs md:text-sm text-background-100/85 flex gap-2"
                        >
                          <i className="ri-flashlight-line text-primary-300 mt-0.5" />
                          {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}